import { ui_service_ip } from "./ip_details";
import { call_post_api, call_get_api, call_delete_api, call_update_api } from "./event_handling";
/**
 * Generic function to handle API calls based on the method type.
 * @param {string} method - The HTTP method (GET, POST, UPDATE, DELETE).
 * @param {string} endpoint - The endpoint for the API call.
 * @param {Object} params - The parameters or request body for the API call.
 * @returns {Object} - The result from the API call.
 */
async function handleApiCall(method, endpoint, params) {
    try {
        let result;
        switch (method.toUpperCase()) {
            case "GET":
                result = await call_get_api(ui_service_ip, endpoint, params);
                break;

            case "POST":
                result = await call_post_api(ui_service_ip, endpoint, params);
                break;

            case "PUT":
            case "UPDATE":
                result = await call_update_api(ui_service_ip, endpoint, params);
                break;

            case "DELETE":
                result = await call_delete_api(ui_service_ip, endpoint, params);
                break;

            default:
                throw new Error(`Unsupported HTTP method: ${method}`);
        }

        return result; // Return the result from the API
    } catch (error) {
        console.error(`Error during ${method} request to ${endpoint}:`, error); // Log any errors
    }
}

/**
 * Function to test a data source connection (POST).
 * @param {Object} requestParams - The request body containing connection details.
 * @returns {Object} - The result from the API call.
 */
export function testDataSource(requestParams) {
    //return {"schemas":["TPCDS_SF100TCL","TPCDS_SF10TCL","TPCH_SF10","TPCH_SF100","TPCH_SF1000","TPCH_SF1"],"stages":[{"name":"Validate Account Name","stage":1,"status":true},{"name":"Validate Security Credentials","stage":2,"status":true},{"name":"Validate Database","stage":3,"status":true}],"status_code":200,"status_message":"Connection Successful"}
     return handleApiCall("POST", "test_datasource", requestParams);
}

/**
 * Function to create a new data source (POST).
 * @param {Object} requestParams - The request body containing datasource configuration.
 * @returns {Object} - The result from the API call.
 */
export function createDataSource(requestParams) {
    return handleApiCall("POST", "datasource", requestParams);
}

/**
 * Function to create a new data source (POST).
 * @param {Object} requestParams - The request body containing datasource configuration.
 * @returns {Object} - The result from the API call.
 */
export function updateDataSource(requestParams) {
    return handleApiCall("PUT", "datasource", requestParams);
}


/**
 * Function to delete an existing data source (DELETE).
 * @param {Object} requestParams - Contains the ID or details needed to delete a datasource.
 * @returns {Object} - The result from the API call.
 */
export function deleteDataSource(requestParams) {
    return handleApiCall("DELETE", "datasource", requestParams);
}


/**
 * Function to get all existing data sources (GET).
 * @param {Object} requestParams - Optional query params for filtering.
 * @returns {Object} - List of all datasources.
 */
export function getAllDataSources(requestParams) {
  //return {"code":200,"datasources":[{"auto_config_status":"initialised","connector_type":"snow_flake","created_time":"2025-12-11T09:42:23.015644","data_store_type":"database","datasource_id":1,"datasource_name":"Test Data_updated","env_id":1,"env_name":"test","status_text":null},{"auto_config_status":"initialised","connector_type":"snow_flake","created_time":"2025-12-11T13:28:00.601875","data_store_type":"database","datasource_id":2,"datasource_name":"Freont End testing ","env_id":1,"env_name":"test","status_text":null}],"message":"Successfully fetched"}
  return handleApiCall("GET", "datasources", requestParams);
}



/**
 * Function to get all existing data sources (GET).
 * @param {Object} requestParams - Optional query params for filtering.
 * @returns {Object} - List of all datasources.
 */
export function getAllDataSource(requestParams) {
    return handleApiCall("GET", "datasource", requestParams);
}


/**
 * Function to get all existing data sources (GET).
 * @param {Object} requestParams - Optional query params for filtering.
 * @returns {Object} - List of all datasources.
 */
export function editDataSource(requestParams) {
 /*   return  {
    "code": 200,
    "datasource": {
        "auth_config": {
            "password": "Qualdo@1234567",
            "private_key": "",
            "private_key_pwd": "",
            "tenant_id": "1",
            "user": "Yaalini"
        },
        "auto_config_status": "initialised",
        "connector_type": "snow_flake",
        "data_store_type": "database",
        "datasource_config": {
            "database": "SNOWFLAKE_SAMPLE_DATA1",
            "default_error_storage": true,
            "error_storage": "",
            "integration_config": [
                {
                    "database": "SNOWFLAKE_SAMPLE_DATA",
                    "datasetToBeProcessed": "specifiedDataset",
                    "default_error_storage": true,
                    "error_storage": "",
                    "integration_name": "integration4",
                    "partitions": [
                        {
                            "column_name": "S_COUNTRY",
                            "dataset_name": "STORE",
                            "partition_name": "p1",
                            "partition_type": "column"
                        }
                    ],
                    "schema": "TPCDS_SF10TCL",
                    "table_names": [
                        {
                            "created_time": "D_DATE",
                            "match_exact": "match_exact",
                            "partition_type": "column",
                            "start_index_check_box": "true",
                            "start_index_type": "incremental data identifier",
                            "start_with": "1900-01-02",
                            "start_with_query": "",
                            "table": "DATE_DIM"
                        },
                        {
                            "created_time": "",
                            "match_exact": "",
                            "partition_type": "column",
                            "start_index_check_box": "false",
                            "start_index_type": "incremental data identifier",
                            "start_with": "",
                            "start_with_query": "",
                            "table": "STORE"
                        },
                        {
                            "created_time": "CC_REC_END_DATE",
                            "match_exact": "match_exact",
                            "partition_type": "column",
                            "start_index_check_box": "true",
                            "start_index_type": "custom query",
                            "start_with": "",
                            "start_with_query": "CC_REC_END_DATE > '2000-01-01'",
                            "table": "CALL_CENTER"
                        }
                    ],
                    "url": "vqwfums-ed87637.snowflakecomputing.com",
                    "ware_house": "COMPUTE_WH"
                },
                {
                    "database": "SNOWFLAKE_SAMPLE_DATA",
                    "datasetToBeProcessed": "specifiedDataset",
                    "default_error_storage": true,
                    "error_storage": "",
                    "integration_name": "integration3",
                    "partitions": [
                        {
                            "column_name": "S_COUNTRY",
                            "dataset_name": "STORE",
                            "partition_name": "p1",
                            "partition_type": "column"
                        }
                    ],
                    "schema": "TPCDS_SF10TCL",
                    "table_names": [
                        {
                            "created_time": "D_DATE",
                            "match_exact": "match_exact",
                            "partition_type": "column",
                            "start_index_check_box": "true",
                            "start_index_type": "incremental data identifier",
                            "start_with": "1900-01-02",
                            "start_with_query": "",
                            "table": "DATE_DIM"
                        },
                        {
                            "created_time": "",
                            "match_exact": "",
                            "partition_type": "column",
                            "start_index_check_box": "false",
                            "start_index_type": "incremental data identifier",
                            "start_with": "",
                            "start_with_query": "",
                            "table": "STORE"
                        },
                        {
                            "created_time": "CC_REC_END_DATE",
                            "match_exact": "match_exact",
                            "partition_type": "column",
                            "start_index_check_box": "true",
                            "start_index_type": "custom query",
                            "start_with": "",
                            "start_with_query": "CC_REC_END_DATE > '2000-01-01'",
                            "table": "CALL_CENTER"
                        }
                    ],
                    "url": "vqwfums-ed87637.snowflakecomputing.com",
                    "ware_house": "COMPUTE_WH"
                }
            ],
            "schemaToBeProcessed": "specifiedSchema",
            "url": "vqwfums-ed87637.snowflakecomputing.com",
            "ware_house": "COMPUTE_WH"
        },
        "datasource_name": "Test Data7",
        "env_id": 1,
        "last_processed_time": "Mon, 08 Dec 2025 10:27:19 GMT",
        "mode": "manualConfig",
        "status_code": 1,
        "status_text": null,
        "tenant_id": 1
    },
    "message": "Successfully fetched"
}*/

    return handleApiCall("GET", "datasource", requestParams);
}


/**
 * Function to test a data source connection (POST).
 * @param {Object} requestParams - The request body containing connection details.
 * @returns {Object} - The result from the API call.
 */
export function testIntegration(requestParams) {
     return handleApiCall("POST", "test_integration", requestParams);
}


/**
 * Function to test a data source connection (POST).
 * @param {Object} requestParams - The request body containing connection details.
 * @returns {Object} - The result from the API call.
 */
export function editIntegrationById(requestParams) {
     return handleApiCall("GET", "integration", requestParams);
}

export function updateIntegrationById(requestParams) {
     return handleApiCall("PUT", "/integrations", requestParams);
}

/** GET current global scan / sleep interval */
export function getSleepTime(requestParams) {
    return handleApiCall("GET", "sleep_time", requestParams);
}

/** PUT update global scan / sleep interval */
export function updateSleepTime(requestParams) {
    return handleApiCall("PUT", "sleep_time", requestParams);
}

